import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { useAirlineServices,useAirportConsultancy,useCommercialLeasing } from "../BusinessOppurtunities/BusinessOppurtunities.hook";
import { fields } from "../MediaCentre/constants";
import { post, put } from "~/Services";
import { HomePageBanner } from "./HomepageBanner/HomePageBanner";
import SpotLight from "./SpotLight/SpotLight";
import Publications from "./Publications/Publications";
import { Icon } from "@iconify/react";
const Homepage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const { data: airlineServicesData, isLoading: isLoadingAirlineServices } = useAirlineServices();
  const { data: airportConsultancyData, isLoading: isLoadingAirportConsultancy } = useAirportConsultancy();

  useEffect(() => {
    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");

    if (!activeTab) {
      navigate(`/dedicated/corporate/homepage?activeTab=homePageBanner`, { replace: true });
    } else if (activeTab === "spotlightcards" && !subActiveTab) {
      navigate(`/dedicated/corporate/homepage?activeTab=spotlightcards&subActiveTab=smallcards`, { replace: true });
    }
  }, [query, navigate]);

  const items = [
    {
      label: "Homepage Banner",
      key: "homePageBanner",
      children: 
    //   (
    //     <DynamicForm
    //       config={AirlineServicesConfig}
    //       onSubmit={(data, buttonValue) =>
    //         onSubmit(
    //           data,
    //           `https://corporate-nprod-cms.myairports.com.my/api/page-content/102`,
    //           "UPDATE",
    //           "PATCH",
    //           buttonValue == "save" ? "DRAFT" : "PENDING"
    //         )
    //       }
    //     />
    //   ),
    (<HomePageBanner/>)
    },
    {
      label: "Spotlight Cards",
      key: "spotlightcards",
      children: (
        // <DynamicForm
        //   config={AirlineServicesConfig}
        //   onSubmit={(data, buttonValue) =>
        //     onSubmit(
        //       data,
        //       `https://corporate-nprod-cms.myairports.com.my/api/page-content/102`,
        //       "UPDATE",
        //       "PATCH",
        //       buttonValue == "save" ? "DRAFT" : "PENDING"
        //     )
        //   }
        // />
        <SpotLight/>
      ),
    },
    {
        label: "Publications",
        key: "publications",
        children: (
        //   <DynamicForm
        //     config={AirlineServicesConfig}
        //     onSubmit={(data, buttonValue) =>
        //       onSubmit(
        //         data,
        //         `https://corporate-nprod-cms.myairports.com.my/api/page-content/102`,
        //         "UPDATE",
        //         "PATCH",
        //         buttonValue == "save" ? "DRAFT" : "PENDING"
        //       )
        //     }
        //   />
        <Publications/>
        ),
      },
  ];

  const handleProductManagement=(activeTab:any)=>{
    if(activeTab === 'homePageBanner') {
      return (<Button
        onClick={() => {
          navigate("/dedicated/corporate/homepagebanner/add");
        }}
        icon={<Icon icon={"lucide:plus"} />}
        >
          Add Homepage Banner
        </Button>
      )
    } else if(activeTab === 'spotlightcards' && query.get('subActiveTab')==='smallcards') {
        return (<Button
        onClick={() => {
          navigate("/dedicated/corporate/spotlight/smallcards/add");
        }}
        icon={<Icon icon={"lucide:plus"} />}
        >
          Add Small Card
        </Button>
      )
    } 
  //   else if(activeTab === 'spotlightcards' && query.get('subActiveTab')==='largecards') {
  //     return (<Button
  //     onClick={() => {
  //       navigate("/dedicated/corporate/spotlight/largecards/add");
  //     }}
  //     icon={<Icon icon={"lucide:plus"} />}
  //     >
  //       Add Large Card
  //     </Button>
  //   )
  // } 
    else if(activeTab === 'publications') {
        return (<Button
        onClick={() => {
          navigate("/dedicated/corporate/publications/add");
        }}
        icon={<Icon icon={"lucide:plus"} />}
        >
          Add Publications
        </Button>
      )
    } 
  }

  return (
    <ContentWrapper
      title={"Homepage"}
      actionItems={handleProductManagement(query.get('activeTab'))}
      loading={isLoadingAirlineServices || isLoadingAirportConsultancy}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};

export default Homepage